export const isDedicatedAppHost = () => window.location.hostname.toLowerCase() === 'app.intelimove.com.br';
export const APP_ORIGIN = 'https://app.intelimove.com.br';
